import { render, staticRenderFns } from "./admin-api-access-page.vue?vue&type=template&id=00686f58&"
import script from "./admin-api-access-page.vue?vue&type=script&lang=js&"
export * from "./admin-api-access-page.vue?vue&type=script&lang=js&"
import style0 from "./admin-api-access-page.vue?vue&type=style&index=0&id=00686f58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports